import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.493 3.901L13 9h2.266H5a1 1 0 00-1 1v4c0 2.592 1.61 4.855 4.002 6.065A1 1 0 009 21h6a1 1 0 00.998-.935C18.39 18.855 20 16.592 20 14v-4a1 1 0 00-1-1h-3.734l2.032-4.221a1.004 1.004 0 00-1.805-.878zM12 19c-3.573 0-6-2.481-6-5h12c0 2.519-2.427 5-6 5zm6-7v-1H6v1h12z",
      fill: "#2d6ded"
    }
  )
);
export {
  a as default
};
